import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Alert from '../alert';
import useFileUpload from '../../hooks/use-file-upload';
import Input from './input';
import spacer from './spacer';

const Wrapper = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  ${({ $noSpacer }) => !$noSpacer && spacer}
`;

const FileInput = ({
  $noSpacer,
  placeholder,
  onChange,
  setBlockFormSendButton,
  value, // uncontrol the input
  valueAttribute = 'id',
  ...props
}) => {
  const {
    upload,
    result,
    loading,
    error,
  } = useFileUpload();
  const [remoteValue, setRemoteValue] = useState(null);

  useEffect(() => {
    if (setBlockFormSendButton) {
      setBlockFormSendButton(loading);
    }
  }, [
    setBlockFormSendButton,
    loading,
  ]);

  useEffect(() => {
    if (!result) {
      return;
    }
    if (valueAttribute === 'id') {
      setRemoteValue(result.id);
    } else {
      setRemoteValue(result[valueAttribute]);
    }
  }, [
    result,
    valueAttribute,
  ]);

  useEffect(() => {
    if (remoteValue && remoteValue !== value) {
      onChange({ target: { value: remoteValue } });
    }
  }, [
    remoteValue,
    value,
    onChange,
  ]);

  const fileChange = (event) => {
    if (event.target.validity && !event.target.validity.valid) {
      return;
    }

    upload(event.target.files[0]);
  };

  const accept = [
    'image/*',
    'video/*',
    '.pdf',
    'application/pdf',
    '.xls',
    'application/vnd.ms-excel',
    '.xlsx',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    '.doc',
    'application/msword',
    '.docx',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    '.odt',
    'application/vnd.oasis.opendocument.text',
    '.csv',
    'text/csv',
    '.txt',
    'text/plain',
    '.rtf',
    'application/rtf',
  ];

  return (
    <div>
      {error && <Alert $danger>{error?.message}</Alert>}
      <Wrapper $noSpacer={$noSpacer}>
        {placeholder && (
          <label htmlFor={props.name}>{placeholder}:</label>
        )}
        <Input
          {...props}
          type="file"
          onChange={fileChange}
          disabled={loading}
          readOnly={loading}
          accept={accept.join(',')}
          $noSpacer
        />
      </Wrapper>
    </div>
  );
};

export default FileInput;
